module.exports = __webpack_public_path__ + "img/children-1.92363e73.jpg";